import React from "react";
import LegalPage from "../components/LegalPage";
import { BRAND } from "../lib/brand";

export default function ObchodniPodminky() {
  return (
    <LegalPage
      eyebrow="Smluvní ujednání"
      title="Obchodní podmínky"
      intro="Všeobecné obchodní podmínky pronájmu vozidel autopůjčovny KAME."
      sections={[
        { h: "1. Úvodní ustanovení", p: `Tyto obchodní podmínky upravují vztah mezi autopůjčovnou KAME (${BRAND.address.full}) jako pronajímatelem a zákazníkem jako nájemcem vozidla.` },
        { h: "2. Podmínky pronájmu", list: [
          "Minimální věk řidiče je 21 let a řidičský průkaz platný alespoň 1 rok.",
          "Nájemce je povinen předložit dva platné doklady totožnosti.",
          "Při převzetí vozu se skládá vratná kauce dle kategorie vozidla.",
        ]},
        { h: "3. Rezervace a platba", list: [
          "Rezervaci lze provést online nebo telefonicky.",
          "Platba probíhá při převzetí vozu hotově nebo kartou, případně zálohou převodem na bankovní účet předem.",
          "Ceny jsou uvedeny bez DPH a zahrnují pojištění. Nájezd 300–500 km/den.",
        ]},
        { h: "4. Storno podmínky", p: "Rezervaci lze bezplatně zrušit nejpozději 24 hodin před sjednaným termínem převzetí vozu. Při pozdějším storování může být účtován storno poplatek." },
        { h: "5. Povinnosti nájemce", list: [
          "Užívat vozidlo pouze k obvyklému účelu a v souladu s pokyny výrobce.",
          "Vrátit vozidlo ve sjednaném termínu, s plnou nádrží a v čistém stavu.",
          "Neprodleně nahlásit jakoukoliv škodu či pojistnou událost.",
        ]},
        { h: "6. Pojištění", p: "Všechna vozidla mají sjednané povinné ručení i havarijní pojištění. Spoluúčast při pojistné události je uvedena ve smlouvě o pronájmu." },
        { h: "7. Závěrečná ustanovení", p: `Tyto podmínky jsou nedílnou součástí smlouvy o pronájmu. V otázkách zde neupravených se vztah řídí právním řádem České republiky. Kontakt: ${BRAND.email}, ${BRAND.phones[0]}.` },
      ]}
    />
  );
}
